import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit, ChangeDetectorRef  } from '@angular/core';
import { Location } from '@angular/common';
import { IonSelect } from '@ionic/angular';
import { Observable, Subscription, zip, of, combineLatest, ReplaySubject } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';

import * as moment from 'moment';
import 'moment/locale/sl';
import { tap, take, map } from 'rxjs/operators';


import { CartService } from "../../core/services/cart.service"
import { ShopDetailService } from '../../core/services/shop-detail.service';
import { PickSlotService } from '../../core/services/pick-slot.service';

import { PpTranslatePipe } from "../../shared/pipes/pp-translate.pipe"

import { List } from "../../core/models/list.model"
import { Real } from '../../core/models/real.model';
import { Cart } from '../../core/models/cart/cart.model';
import { Pick } from '../../core/models/cart/pick.model';
import { Day } from '../../core/models/day.model';
//import { Attendee } from '../../core/models/cart/attendee.model';

import { Slot } from '../../core/models/cart/slot.model';
import { Combination } from '../../core/models/cart/combination.model';

import { SearchPreferencesService } from '../../core/services/search-preferences.service';
import { TranslateService } from "@ngx-translate/core";

import { ProviderServiceService } from '../../core/services/provider-service.service'
import { ModalController } from '@ionic/angular';
import { ContactUsModalComponent } from './contact-us-modal/contact-us-modal.component';



//import { Employee } from '../../core/models/employee.model';


@Component({
  selector: 'app-pick-slot',
  templateUrl: './pick-slot.page.html',
  styleUrls: ['./pick-slot.page.scss'],
})
export class PickSlotPage implements OnInit, OnDestroy, AfterViewInit  {

  @ViewChild('popover') popover;

  @ViewChild('mySelect', { static: false }) mySelect: IonSelect;

  popoverIsOpen = false;

  days$: Observable<List>;
  days: List;

  daySlots$: Observable<Slot[]>;
  slotCombinations: Combination[];
  slotCombinations$: Observable<Combination[]>;
  morningSlots$: Observable<Slot[]>;
  afternoonSlots$: Observable<Slot[]>;

  initialSlot$:ReplaySubject<Slot> = new ReplaySubject<Slot>();

  private initialSlotsSubscription: Subscription;

  menuStrelec: number;

  selectedDay: string;
  noSlotsAvailable = false;

  selectedTime: string;

  selectedDayObject: Day;

  selectedDayHasSlots = true;
  selectedDayIsOpen = true;

  real$: Observable<Real>;

  real: Real;

  pick: Pick;

  cart: Cart;

  realSubscription: Subscription;

  loader: any;

  loadingMorningSlots = false;
  loadingAfternoonSlots = false;

  services$: Observable<any>;
  servicesSnapshot: {};

  eventFilter: string = 'all';

  constructor(
    private cartService: CartService,
    private shopDetailService: ShopDetailService,
    private pickSlotService: PickSlotService,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
    private searchPreferencesService: SearchPreferencesService,
    public translateService: TranslateService,
    private providerServiceService: ProviderServiceService,
    public ppTranslatePipe: PpTranslatePipe,
    public modalCtrl: ModalController,
    private cdr: ChangeDetectorRef
  ) {
  }


  ngAfterViewInit() {
    if (this.mySelect) {
      this.mySelect.ionFocus.subscribe(() => {
        setTimeout(() => {
          this.removePopoverProperty();
        }, 0);
      });
    }
  }

  removePopoverProperty() {
    const po = document.querySelector('ion-popover');
    if (po) {

      if (po.hasAttribute('popover')) {
        po.removeAttribute('popover');
      }
    }
  }

  async presentModal() {
    const modal = await this.modalCtrl.create({
      component: ContactUsModalComponent,
      componentProps: { 'real': this.real }
      // Any other popover config options you need
    });
    await modal.present();
  }



  getEventName( eventId ) {
    
    let text = 'Dogodek';

    let s = this.servicesSnapshot['id_' + eventId ];

    if ( s ) {
        text = this.ppTranslatePipe.transform(s.name, s.nameTranslations, this.translateService.currentLang );
    }

    return text;

  }

  changedEventFilter(event) {
    this.eventFilter = event.detail.value;
  }

  navigateToServicePick() {
    this.router.navigate( ['/restavracija', this.route.snapshot.params.providerId, this.route.snapshot.params.shopSlug] );
  }

  ngOnInit() {

    this.cart = this.cartService.getCart();
    this.real$ = this.shopDetailService.getReal( this.route.paramMap );
    this.realSubscription = this.real$.subscribe( real =>  { 

      this.real = real;
      this.pick = this.cart.getPickByShopId( parseInt(this.real.id ));

      if ( this.route.snapshot.queryParamMap.get('filter') ) {
        //this.pick.menuStrelec = parseInt( this.route.snapshot.queryParamMap.get('menu') );
        this.eventFilter = this.route.snapshot.queryParamMap.get('filter');
      }

      this.services$ = 
        this.providerServiceService.getServicesForPicking( this.real.selectionItems[0].id, this.pick ).pipe(
        tap( categories => console.log(categories) ),
        map( categories => categories ),
        take(1)
      );


      this.services$.subscribe( categories => {

        let servicesById = {};
        for( let category of categories ) {
          servicesById['id_' + category.id] = category;
        }

        console.log(servicesById);
        this.servicesSnapshot = servicesById;

      });  

      /*if ( !this.pick.areServicesPickedAndDepsOk() ) {
        console.log('services are not picked or deps are not ok...');
        this.router.navigate( ['/restavracija', this.route.snapshot.params.providerId, this.route.snapshot.params.shopSlug] );
        return;
      }*/

      //const attendee = this.pick.getAttendeeByIndex(0);

      //attendee.services

      this.searchPreferencesService.searchPreferences$.subscribe(r => console.log(r));

      this.days$ = zip(
        this.pickSlotService.getDays( real, this.pick.partySize ),
        //of([])
        this.searchPreferencesService.searchPreferences$
      ).pipe(
        tap( ([days, searchPreferences]) => {
          this.days = days; //store for usage in pick-slot
          loadInitialDay( days, searchPreferences );
        }),
        map( ([days, searchPreferences]) => days )
      );

      
      /*this.days$ = this.pickSlotService.getDays( real, attendee.services ).pipe(
        tap (
          days => {
            loadInitialDay( days );
          }
        )
      );*/

      const loadInitialDay = ( days, searchPreferences )  => {

        console.log('a');

        //if slot is already picked, select the picked day - initial load
        if ( this.pick.combination && this.pick.combination.start ) {

          console.log('b');
          console.log(this.pick.combination);

          this.selectedTime = this.pick.combination.start;
          this.selectDay( this.getUnixDay( this.pick.combination.start ) );
          
          //this.slotCombinations$ = this.pickSlotService.getSlotCombinations( this.getUnixTime( this.pick.combination.start ), this.getUnixDay( this.pick.combination.start ), this.real, attendee.services );

        } else { //combination is not picked, check search preferences and set the smartest first day


          console.log('c');
          if ( this.route.snapshot.queryParamMap.get('from') ) {

            console.log(this.route.snapshot.queryParamMap.get('from'));
            this.selectDay( this.route.snapshot.queryParamMap.get('from') );
            return true;

          }

          console.log('e');

          let prefferedDayAvailable: string;

          //check if searchPreferences date period is picked
          if ( searchPreferences.datePeriod && searchPreferences.datePeriod.fromMoment && searchPreferences.datePeriod.toMoment ) {

            console.log('f');
            //pick first available day inside the interval
            var preferredDay = searchPreferences.datePeriod.fromMoment.clone();

            loop:
            while ( preferredDay.isSameOrBefore( searchPreferences.datePeriod.toMoment ) ) {

                for( let day of days.items ) {

                  if ( day.hasSlots && moment(day.date).isSame(preferredDay, 'date') ) {
                    prefferedDayAvailable = day.date;
                    break loop;
                  }

                }

                preferredDay.add(1, 'days');
            }

          } 


          if ( prefferedDayAvailable ) {
            this.selectDay( prefferedDayAvailable );
            console.log('g');
          } else { //just pick the first day available default
            
            let dayHasSlots = false;

            for( let day of days.items ) {
              if ( day.hasSlots ) {
                dayHasSlots = true;
                this.selectDay( day.date );
                console.log(day.date);
                break;
              }
            }

            if ( !dayHasSlots ) {
              this.noSlotsAvailable = true;
            }

          }


        }

      }

    });
  }

  ngOnDestroy() {
    this.realSubscription.unsubscribe();
  }

  private getDayObjectByDate( date, days: List ) {

    if (!days || !days.items) {
      return false;
    }

    for( let day of days.items ) {
      if ( day.date === date ) {
        return day;
      }
    }

    return false;

  }

  private selectDay( date, dayObj: Day = null ) {

    //test
    this.pick.unsetCombination();
    this.selectedTime = null;

    
    let filterEventFreshSet = false;

    if ( !this.eventFilter ) {
      this.eventFilter = 'all';
    
    }

    this.selectedDay = date;

    if ( dayObj ) {
      this.selectedDayObject = dayObj;
    } else {
      this.selectedDayObject = this.getDayObjectByDate( date, this.days );
    }

    // Ensure servicesSnapshot is initialized
    this.servicesSnapshot = this.servicesSnapshot || {};


    if ( this.selectedDayObject && this.selectedDayObject.events ) {

      for( let eventId of this.selectedDayObject.events ) {
       
        let serviceKey = 'id_' + eventId;
        
        if ( this.servicesSnapshot[serviceKey] &&
          this.servicesSnapshot[serviceKey].specialOffer
        ) {
          this.eventFilter = eventId.toString();
          filterEventFreshSet = true;
          break;
        }
        
      } 

    }

    if ( this.eventFilter && !filterEventFreshSet && this.eventFilter != 'all' ) { //set default if no events on that particular day...
      this.eventFilter = 'all';
    }
    

    if ( this.selectedDayObject && this.selectedDayObject.events && this.selectedDayObject.events[0] &&
        this.servicesSnapshot['id_' + this.selectedDayObject.events[0]] &&
        this.servicesSnapshot['id_' + this.selectedDayObject.events[0]].specialOffer
        )  {

      //this.eventFilter = this.selectedDayObject.events[0].toString();
    } 

    if ( this.selectedDayObject && this.selectedDayObject.events && this.selectedDayObject.events[0] &&
        this.servicesSnapshot['id_' + this.selectedDayObject.events[1]] &&
        this.servicesSnapshot['id_' + this.selectedDayObject.events[1]].specialOffer
        )  {

      //this.eventFilter = this.selectedDayObject.events[1].toString();
    } 

    let attendee = this.pick.getAttendeeByIndex(0);


    this.daySlots$ = this.pickSlotService.getDaySlots( date, this.real, this.pick.partySize );
    this.loadingMorningSlots = true;
    this.loadingAfternoonSlots = true;
    this.morningSlots$ = this.pickSlotService.getMorningSlots( this.daySlots$ ).pipe( tap( () => this.loadingMorningSlots = false ) );
    this.afternoonSlots$ = this.pickSlotService.getAfternoonSlots( this.daySlots$ ).pipe( tap( () => this.loadingAfternoonSlots = false ) );


    //set first slot if there is only one option
    if (this.initialSlotsSubscription) {
      this.initialSlotsSubscription.unsubscribe();
    }


    this.initialSlotsSubscription = combineLatest([

      this.morningSlots$,
      this.afternoonSlots$

    ]).subscribe(([morningSlots, afternoonSlots]) => {

      if ( morningSlots.length === 1 && afternoonSlots.length === 0 ) {
        console.log( 'prvi jutranji' );
        console.log( morningSlots[0] );
        this.initialSlot$.next( morningSlots[0] )
      }

      if ( afternoonSlots.length === 1 && morningSlots.length === 0 ) {
        console.log( 'prvi popoldanski' );
        console.log( afternoonSlots[0] );
        this.initialSlot$.next( afternoonSlots[0] )
      }

    });


  }

  onPartySizeChange( newPartySize) {

    if (999 === newPartySize.detail.value) {
      this.presentModal();

      //hack to refresh 
      this.pick.partySize = 3;
      setTimeout(() => this.pick.partySize = 2, 0);

      //this.cdr.detectChanges();
      return false;
    }

    this.pick.partySize = newPartySize.detail.value;
    this.days$ = this.pickSlotService.getDays( this.real, this.pick.partySize );
    this.selectDay( this.selectedDay );



  }

  onDaySelected( day: Day ) {
    this.selectedDayHasSlots = day.hasSlots;
    this.selectedDayIsOpen = day.isOpen;
    this.selectDay( day.date, day );
  }

  getUnixDay( dateString ) {
    return moment( dateString ).format('YYYY-MM-DD');
  }

  getUnixTime( dateTimeString ) {
    return dateTimeString.substr( dateTimeString.indexOf('T')+1 );
  }

  toggleSlot( obj ) {

    let slot = obj['slot'];

    console.log(obj);

    let eventPreference = obj['eventPreference'] ? obj['eventPreference']: null;
    let slotClick = obj['slotClick'] ? obj['slotClick']: false;

    if ( this.selectedTime == slot.start && slotClick  ) {
      this.pick.unsetCombination();
      this.selectedTime = null;
    } else {

      console.log('a');
      console.log(obj);

      if ( slot.otherCombinationsAvailable && slot.start ) {
        let attendee = this.pick.getAttendeeByIndex(0);
        //@todo selectedDay replace with day from slot
        this.slotCombinations$ = this.pickSlotService.getSlotCombinations( this.getUnixTime( slot.start ), this.getUnixDay( slot.start ), this.real, this.pick.partySize );
      }

      let template = slot.anyCombination;
      
      if ( eventPreference === 20957) {
        template.selectionItems.slice(0, 1);
        template.selectionItems[0].table = 'https://api.pricepilot.io/providers/437/services/20831/selectionitems/4227';
      }

      if ( eventPreference === 21199) {
        template.selectionItems.slice(0, 1);
        template.selectionItems[0].table = 'https://api.pricepilot.io/providers/437/services/20831/selectionitems/4240';
      }

      /*if (eventPreference === '22837' ) {
          this.pick.partySize = 1;
      }*/
        

      let c = new Combination(template);

      c.setEventPreference( eventPreference );
      c.setRegularOfferAvailable( slot.regularOfferAvailable );

      this.pick.setCombination( c );

      console.log(c);

      console.log(slot.start);

      this.selectedTime = slot.start;
    }
    
  }


  goBack(){
    this.location.back();
  }

}
